import React from 'react';

const Ellipsis: React.FC = ({ children }) => (
  <span className="ellipsis" title={String(children)}>
    {children}
  </span>
);

export default Ellipsis;
